import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "data/backOfficeConnector";
import type EventBus from "services/eventBus";
import OutgoingTransferPaymentResponse from "entities/outgoingTransferPaymentResponse";
import OutgoingTransferPaymentDetailsResponse from "entities/outgoingTransferPaymentDetailsResponse";
import type OutgoingTransferPaymentFilters from "entities/outgoingTransferPaymentsRequest";
import type { IPagination } from "data/types";
import { serializeFilters } from "utils/filters";

export default class OutgoingTransferRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAllOutgoingTransferPayments(pagination: IPagination, filters: OutgoingTransferPaymentFilters, abortSignal: AbortSignal) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("outgoing_transfer_payments")
          .postPagedEntities<OutgoingTransferPaymentResponse>(
            serializeFilters(filters, false),
            OutgoingTransferPaymentResponse,
            abortSignal,
            pagination
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  getAllOutgoingTransferPaymentsExport(filters: OutgoingTransferPaymentFilters) {
    return this.callApi(
      api => api.all("finance").all("outgoing_transfer_payments").all("report").postOnly(serializeFilters(filters, false)),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  async getOutgoingTransferPayment(itemId: string) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .one("outgoing_transfer_payments", itemId)
          .getEntity<OutgoingTransferPaymentDetailsResponse>(OutgoingTransferPaymentDetailsResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.2" }),
      }
    );
  }
}
